import "./component-library84.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "Paragraph",
  props: {
    theme: {
      type: String,
      default: void 0,
      validator(value) {
        return ["light", "dark", "primary", void 0].includes(value);
      }
    },
    align: { type: String, default: void 0 },
    isSizeBig: { type: Boolean },
    text: { type: String, default: "" },
    noMargin: { type: Boolean }
  },
  computed: {
    classes() {
      const modifier = [];
      if (this.theme)
        modifier.push(`text--${this.theme}`);
      if (this.align)
        modifier.push(`text--${this.align}`);
      if (!this.noMargin)
        modifier.push(`paragraph--mb`);
      if (this.isSizeBig)
        modifier.push("paragraph--size-big");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return !_vm.text ? _c("p", { staticClass: "paragraph", class: _vm.classes }, [_vm._t("default")], 2) : _c("p", { staticClass: "paragraph", class: _vm.classes, domProps: { "innerHTML": _vm._s(_vm.text) } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "179b5b3a",
  null,
  null
);
const Paragraph = __component__.exports;
export {
  Paragraph as default
};
